import { useState } from "react";
import { Download, Share, SquarePlus, X } from "lucide-react";
import { usePwaInstall } from "../../hooks/usePwaInstall";

const PasoIOS = ({ icono, children }) => (
  <li className="flex items-start gap-3">
    <span className="w-7 h-7 rounded-lg bg-white/10 flex items-center justify-center shrink-0 mt-0.5">
      {icono}
    </span>
    <span className="text-white/75 text-[13px] leading-relaxed">{children}</span>
  </li>
);

const InstruccionesIOS = ({ onClose }) => (
  <div
    className="fixed inset-0 z-[90] flex items-end sm:items-center justify-center p-4"
    style={{ background: "rgba(0,0,0,.6)" }}
    onClick={onClose}
  >
    <div
      className="w-full max-w-sm rounded-3xl p-5"
      style={{
        background: "linear-gradient(150deg,#1e1140,#2b0f3d 60%,#3d0f38)",
        border: "1px solid rgba(255,255,255,.12)",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex items-start justify-between gap-3 mb-4">
        <div>
          <p className="text-white font-bold text-[15px]">Instalar en tu iPhone o iPad</p>
          <p className="text-white/50 text-[12px] mt-1">
            Safari no permite instalarla automáticamente, son dos pasos.
          </p>
        </div>
        <button
          onClick={onClose}
          aria-label="Cerrar"
          className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center shrink-0"
        >
          <X size={15} className="text-white/70" />
        </button>
      </div>

      <ol className="space-y-3">
        <PasoIOS icono={<Share size={14} className="text-white/70" />}>
          Toca el botón <span className="text-white font-semibold">Compartir</span> en la barra de
          Safari.
        </PasoIOS>
        <PasoIOS icono={<SquarePlus size={14} className="text-white/70" />}>
          Elige <span className="text-white font-semibold">Añadir a pantalla de inicio</span> y
          confirma.
        </PasoIOS>
      </ol>
    </div>
  </div>
);

export const InstallAppButton = ({ className = "" }) => {
  const { puedeInstalar, requierePasosManuales, install } = usePwaInstall();
  const [mostrarPasos, setMostrarPasos] = useState(false);

  // Ya instalada, o un navegador que no soporta instalación: no ocupamos sitio.
  if (!puedeInstalar && !requierePasosManuales) return null;

  return (
    <>
      <button
        onClick={() => (puedeInstalar ? install() : setMostrarPasos(true))}
        aria-label="Instalar la aplicación"
        className={`flex items-center gap-1.5 rounded-full bg-white/15 hover:bg-white/25 transition-colors px-2.5 py-1 shrink-0 ${className}`}
        style={{ border: "1px solid rgba(255,255,255,.25)" }}
      >
        <Download size={13} className="text-white shrink-0" />
        <span className="hidden xs:inline text-white text-[11px] font-semibold">Instalar</span>
      </button>

      {mostrarPasos && <InstruccionesIOS onClose={() => setMostrarPasos(false)} />}
    </>
  );
};
